declare var FroalaEditor: any;

export function registerFroalaImageAlignCommand(): void {
  if (typeof FroalaEditor === 'undefined') {
    return;
  }

  const getImageAlignmentTarget = (imageElement: HTMLElement | null | undefined): HTMLElement | null => {
    return imageElement?.closest?.('.fr-img-caption') as HTMLElement || imageElement || null;
  };

  const clearImageAlignmentState = (targetElement: HTMLElement, imageElement?: HTMLElement | null): void => {
    [targetElement, imageElement].forEach((element) => {
      if (!element) {
        return;
      }

      element.classList.remove('fr-dii', 'fr-dib', 'fr-fil', 'fr-fir');
      element.style.removeProperty('display');
      element.style.removeProperty('float');
      element.style.removeProperty('margin-left');
      element.style.removeProperty('margin-right');
      element.style.removeProperty('text-align');
    });
  };

  const applyImageAlignmentState = (imageElement: HTMLElement | null | undefined, alignValue: string): void => {
    const targetElement = getImageAlignmentTarget(imageElement);
    if (!targetElement || !['left', 'center', 'right'].includes(alignValue)) {
      return;
    }

    clearImageAlignmentState(targetElement, imageElement || null);

    if (alignValue === 'center') {
      targetElement.classList.add('fr-dib');
      return;
    }

    targetElement.classList.add('fr-dii', alignValue === 'right' ? 'fr-fir' : 'fr-fil');
  };

  const imageAlignOptions: Record<string, string> = {
    left: 'Align Left',
    center: 'Align Center',
    right: 'Align Right'
  };

  const imageAlignCommand = {
    type: 'dropdown',
    title: 'Align',
    options: imageAlignOptions,
    html: function(this: any): string {
      let dropdownHtml = '<ul class="fr-dropdown-list" role="presentation">';

      Object.keys(imageAlignOptions).forEach((alignValue) => {
        const label = this.language.translate(imageAlignOptions[alignValue]);
        dropdownHtml += `<li role="presentation"><a class="fr-command fr-title" tabIndex="-1" role="option" data-cmd="imageAlign" data-param1="${alignValue}" title="${label}">${this.icon.create(`image-align-${alignValue}`)}<span class="fr-sr-only">${label}</span></a></li>`;
      });

      return `${dropdownHtml}</ul>`;
    },
    callback: function(this: any, _command: string, alignValue: string): void {
      if (!this.image || !alignValue) {
        return;
      }

      const selectedImage = this.image.get?.();
      const selectedImageElement = selectedImage?.[0] || selectedImage?.get?.(0);

      this.image.display?.(alignValue === 'center' ? 'block' : 'inline');
      this.image.align?.(alignValue);
      applyImageAlignmentState(selectedImageElement, alignValue);
    },
    refresh: function(this: any, button: any): void {
      this.image.refreshAlign(button);
    },
    refreshOnShow: function(this: any, button: any, dropdown: any): void {
      this.image.refreshAlignOnShow(button, dropdown);
    }
  };

  if (typeof FroalaEditor.RegisterCommand === 'function') {
    FroalaEditor.RegisterCommand('imageAlign', imageAlignCommand);
  }

  if (FroalaEditor.COMMANDS) {
    FroalaEditor.COMMANDS.imageAlign = imageAlignCommand;
  }
}